import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { UserRole, UserStatus } from '@wellverse/shared-ts';

export const UserCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'users' });

  return (
    <Create resource="users" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, type: 'email' }]}
        >
          <Input type="email" placeholder="user@example.com" />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, min: 8 }]}
        >
          <Input.Password placeholder="••••••••" />
        </Form.Item>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[{ required: true }]}
        >
          <Input placeholder="John" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[{ required: true }]}
        >
          <Input placeholder="Doe" />
        </Form.Item>
        <Form.Item label="Role" name="role" initialValue={UserRole.USER}>
          <Select>
            <Select.Option value={UserRole.USER}>User</Select.Option>
            <Select.Option value={UserRole.MODERATOR}>Moderator</Select.Option>
            <Select.Option value={UserRole.ADMIN}>Admin</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Status" name="status" initialValue={UserStatus.ACTIVE}>
          <Select>
            <Select.Option value={UserStatus.ACTIVE}>Active</Select.Option>
            <Select.Option value={UserStatus.INACTIVE}>Inactive</Select.Option>
            <Select.Option value={UserStatus.PENDING}>Pending</Select.Option>
            <Select.Option value={UserStatus.SUSPENDED}>Suspended</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Create>
  );
};
